/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const archivedListConfig = {
  url: 'https://kali-dev-dc.vlinder.io/digicert/certificate/find',
  bulkOptions: [
    {
      value: 'revoke',
      label: 'Revoke',
    },
  ],
  ultTableHeaderUser: [
    'Name',
    'Policy No',
    'Coverage',
    'Premium',
    'Status',
    'Policy Option',
    'Date Purchased',
    'Action',
  ],
  ultTableHeader: [
    'Name',
    'Policy No',
    'Coverage',
    'Premium',
    'Status',
    'Policy Option',
    'Date Purchased',
    'Action',
  ],
  ultUsers: [
    {
      id: '1',
      verified: true,
      status: 'active',
      name: 'Kaliraj Subra Manian',
      policyNo: '123-456-7890',
      email: 'example@vlinder.io',
      dateCreated: '22 July 2022',
      coverage: '$1500',
      policyOption: 'coverage',
      premium: '$2500',
    },
    {
      id: '2',
      verified: true,
      status: 'active',
      name: 'Bonnie Green',
      policyNo: '987-654-321',
      email: 'example@vlinder.io',
      coverage: '$1500',
      dateCreated: '20 July 2022',
      policyOption: 'coverage',
      premium: '$2500',
    },
    {
      id: '3',
      verified: false,
      status: 'revoked',
      name: 'Scott Anderson',
      policyNo: '132-783-678',
      email: 'example@vlinder.io',
      coverage: '$1500',
      dateCreated: '18 July 2022',
      policyOption: 'coverage',
      premium: '$2500',
    },
    {
      id: '4',
      verified: true,
      status: 'disputed',
      name: 'Harris Anderson',
      policyNo: '863-282-982',
      email: 'example@vlinder.io',
      coverage: '$1500',
      dateCreated: '22 July 2022',
      policyOption: 'coverage',
      premium: '$2500',
    },
  ],
  activePage: 1,
  pageSize: 10,
  totalCount: 4,
  totalPages: 1,
};
